import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { ChatListingPreview } from '../ngrx-store/app.state'
import { accommodationTypeLabel, rentIntervalLabel } from '../utils/accommodation.util'
import { thumbnailUrl } from '../utils/sale.util'

/**
 * "About: Standing fan" above the first message of a chat started from a listing: its photo, name
 * and price, opening the listing - or "No longer listed" once its poster deleted it.
 */
@Component({
  selector: 'app-chat-listing-card',
  templateUrl: './chat-listing-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatListingCardComponent {
  @Input() listing!: ChatListingPreview

  get link(): string {
    return `/${this.listing.type === 'sale' ? 's' : 'a'}/${this.listing.slug_id}`
  }

  get title(): string {
    return this.listing.type === 'sale' ? this.listing.title : accommodationTypeLabel(this.listing.title)
  }

  /** '₦18,000', '₦250,000/year', 'Free lodge' - like the sale and house cards. */
  get price(): string {
    if (this.listing.type === 'accommodation' && this.listing.rent_interval === 'free') return 'Free lodge'
    if (!this.listing.price) return ''
    const amount = '₦' + new Intl.NumberFormat('en-NG').format(this.listing.price)
    return this.listing.type === 'accommodation' ? amount + rentIntervalLabel(this.listing.rent_interval) : amount
  }

  get photo(): string | undefined {
    return thumbnailUrl(this.listing.photo_url ?? undefined, 80)
  }

  get placeholderIcon(): string {
    return this.listing.type === 'sale' ? 'sell' : 'apartment'
  }
}
